import { SearchCategory } from '../../UniversalSearch.constants';

export const CategoryOrder = [
  SearchCategory.NAVIGATION,
  SearchCategory.FIELDS,
  SearchCategory.ACTIONS,
  SearchCategory.RECORDS,
  SearchCategory.DOCUMENTS,
];

export const SEARCH_SUGGESTIONS = [
  'Try "Loan Amount" or "Property"',
  'Search for tabs like "Borrowers" or "Financial Information"',
  'Look for sections like "Lock Info" or "Appraisal"',
];
